<ion-app>
  <app-loading></app-loading>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
